import Store from '../../store'
import OverlayTip from '../UEapi/OverlayTip'
import UEapi from '../UEapi/UEapi'
import cameraList from '../configs/cameraList'
// console.log(Store.state);
// 地图散点点击逻辑
export default class MapEvent {
  static pointClick(res) {
    console.log(res, res.detail.idLayer);
    let focusDistance = {
      默认场景: 3000000,
      中国: 3000000,
      北京: 130000,
      园区: 15,
      楼层: 10,
      房间: 10,
      机柜组机房: 10,
      电池组机房: 10,
      UPS设备机房: 10,
      机柜: 10,
    }
    UEapi.Camera.focusByLayer({
      id: res.detail.idObj,
      idLayer: res.detail.idLayer,
      layerType: 'landmarkLayer',
      distance: focusDistance[Store.state.spaceLevel] || 10
    })
    switch (res.detail.idLayer) {
      case '中国-数据中心':
        Store.commit('setRightComponents', 'ShuJuZhongXingSheng')
        break
      case '北京-数据中心':
        Store.commit('setRightComponents', 'ShuJuZhongXingYuanQu')
        break
      case '园区-固定摄像头':
        Store.commit('setObjectInfo', {
          showName: '园区-固定摄像头'
        })
        break
      case '园区-门禁设备':
        Store.commit('setObjectInfo', {
          showName: '园区-门禁设施',
          idObj: res.detail.idObj
        })
        cameraList[`门禁${res.detail.idObj}`] && UEapi.Camera.setCamera(cameraList[`门禁${res.detail.idObj}`]);
        break
      case '园区-人脸识别摄像头':
        Store.commit('setObjectInfo', {
          showName: '园区-人脸识别摄像头'
        })
        break
      case '园区-云台摄像头':
        Store.commit('setObjectInfo', {
          showName: '园区-云台摄像头'
        })
        break
      case '园区-可燃气体探测器':
        Store.commit('setObjectInfo', {
          showName: '园区-可燃气体探测器'
        })
        break
      case '园区-消防烟感':
        Store.commit('setObjectInfo', {
          showName: '园区-消防烟感'
        })
        break
      case '园区-机柜点位':
        // if (!isSelect) {
        //   window.layerConfig.modelOnlyHighlight()
        //   UEapi.Camera.setCamera(cameraList[id])
        //   return
        // }
        UEapi.Camera.setCamera(cameraList[res.detail.idObj])
        setTimeout(() => {
          window.layerConfig.focusJiGui(res.detail.idObj)
        }, 1300)
        break
      default:
        break
    }
  }
  static eventLayerClick(res) {
    switch (res.detail.idLayer) {
      case '园区-告警_设备':
        Store.commit('setObjectInfo', {
          showName: '园区-设备告警'
        })
        break
      default:
        break
    }
  }

  static modelClick(res) {
    console.log('modelClick', res.detail);

    if (res.detail.id.split('_')[2] == '机柜组' && Store.state.spaceLevel !== '机柜') {
      Store.commit('setHighLight', '机柜组')
      window.layerConfig.equipmentCabinetOnlyHighlight(res.detail.id)
      Store.commit('setModelId', res.detail.id)
    }
    if (
      [
        'Box_A01-004-04_机柜容量',
        'C03-004-04_SM_设备机柜',
        'A01-004-04_SM_机柜组',
        'F06-004-07_SM_设备机柜',
        'C03-004-04_SM_配线架',
        'C03-004-04_SM_交换机',
        'C03-004-04_SM_数据服务器_虚拟机',
        'C03-004-04_SM_路由器',
        'C03-004-04_SM_服务器',
        'C03-004-04_SM_网络存储服务器',
        'C03-004-04_SM_GPU服务器'
      ].includes(res.detail.id)
    ) {
      Store.commit('setModelId', res.detail.id)
    }
    switch (res.detail.id) {
      case 'SM_IDC机房楼':
        Store.commit('setRightComponents', 'JianZhu')
        break
      case 'SM_IDC室内04':
        Store.commit('setRightComponents', 'LouCeng')
        break
      // case 'Box_A01-004-04_机柜容量':
      // case 'Box_C03-004-04_机柜容量':
      // case 'Box_F06-004-04_机柜容量':
      case 'C03-004-04_SM_设备机柜':
      case 'A01-004-04_SM_机柜组':
      case 'F06-004-07_SM_设备机柜':
        let JiGui = {
          'A01-004-04_SM_机柜组': 'Box_A01-004-04_机柜容量',
          'C03-004-04_SM_设备机柜': 'Box_C03-004-04_机柜容量',
          'F06-004-07_SM_设备机柜': 'Box_F06-004-04_机柜容量',
        }
        UEapi.Camera.setCamera(cameraList[JiGui[res.detail.id]])
        window.layerConfig.rackOnlyHighlight(res.detail.id)
        if (Store.state.spaceLevel !== '机柜') {
          Store.commit('setRightComponents', 'JiGuiZaixian')
        }
        UEapi.Model.playAnimation({
          id: 'C03-004-04_SM_数据服务器_虚拟机',
          name: '显示_虚拟机机箱',
          state: 'begin'
        });
        break
      case 'C03-004-04_SM_配线架':
        Store.commit('setRightComponents', 'JiQi')
        window.layerConfig.modelOnlyHighlight(res.detail.id)
        UEapi.Camera.setCamera(cameraList[res.detail.id])
        break
      case 'C03-004-04_SM_交换机':
        Store.commit('setRightComponents', 'JiaoHuanJi')
        window.layerConfig.modelOnlyHighlight(res.detail.id)
        UEapi.Camera.setCamera(cameraList[res.detail.id])
        break
      case 'C03-004-04_SM_数据服务器_虚拟机':
        Store.commit('setRightComponents', 'FuWuQiXuNiJi')
        window.layerConfig.modelOnlyHighlight(res.detail.id)
        UEapi.Camera.setCamera(cameraList[res.detail.id])
        break
      case 'C03-004-04_SM_路由器':
        Store.commit('setRightComponents', 'LuYouQi')
        window.layerConfig.modelOnlyHighlight(res.detail.id)
        UEapi.Camera.setCamera(cameraList[res.detail.id])
        break
      case 'C03-004-04_SM_服务器':
        Store.commit('setRightComponents', 'FuWuQiBiaoZhun')
        window.layerConfig.modelOnlyHighlight(res.detail.id)
        UEapi.Camera.setCamera(cameraList[res.detail.id])
        break
      case 'C03-004-04_SM_网络存储服务器':
        Store.commit('setRightComponents', 'JiQi')
        window.layerConfig.modelOnlyHighlight(res.detail.id)
        UEapi.Camera.setCamera(cameraList[res.detail.id])
        break
      case 'C03-004-04_SM_GPU服务器':
        Store.commit('setRightComponents', 'JiQi')
        window.layerConfig.modelOnlyHighlight(res.detail.id)
        UEapi.Camera.setCamera(cameraList[res.detail.id])
        break
      case 'API_C0300404_配线架_正_A40':
      case 'API_C0300404_服务器_背_F02':
        Store.commit('setRightComponents', 'OP1')
        break
      default:
        break
    }
  }
  static modelHover(res) {
    switch (res.detail.id) {
      case 'SM_IDC机房楼':
        // 添加标牌
        // OverlayTip.addModelTipG5(res.detail)
        // Store.commit('setLandmarkLayerIdObj', 'IDC机房楼')
        break
      case 'SM_IDC室内04':
        // 添加标牌
        OverlayTip.addModelTipFloorLongCeng(res.detail)
        Store.commit('setLandmarkLayerIdObj', 'IDC机房F3')
        break;
      default:
        switch (Store.state.spaceLevel) {
          case '楼层':
            if (res.detail.id == 'SM_IDC室内02' ||
              res.detail.id == 'SM_IDC室内03' ||
              res.detail.id == 'SM_IDC室内04' ||
              res.detail.id == 'SM_IDC室内04' ||
              res.detail.id == 'SM_地面' ||
              res.detail.id == 'Click_蓄电池房' ||
              res.detail.id == 'Click_主机房' || (res.detail.id).indexOf('防尘') != -1) {
              return
            }
            if ((res.detail.id).indexOf('机柜') != -1 ||
              (res.detail.id).indexOf('电池组') != -1) {
              OverlayTip.addModelTipClass(res.detail)
            }
            break
          case '机柜组机房':
            if ((res.detail.id).indexOf('机柜') != -1) {
              OverlayTip.addModelTipClass(res.detail)
            }
            break
          case 'UPS设备机房':
            OverlayTip.addModelTipClass(res.detail)
            break
          case '机柜':
            if (res.detail.id == 'C03-004_SM_机柜组' ||
              res.detail.id == 'A01-004-04_SM_机柜组' ||
              res.detail.id == 'C03-004-04_SM_设备机柜' ||
              res.detail.id == 'F06-004-07_SM_设备机柜') {
              return
            }
            OverlayTip.addModelTipClass(res.detail)

            break
          case '电池组机房':
            if (res.detail.id != 'Click_蓄电池房') {
              OverlayTip.addModelTipClass(res.detail)
            }
            break;
          default:
            break;
        }
        break;
    }

  }
  static modelUnhover(res) {
    const {
      prevModelLayer
    } = Store.state
    switch (res.detail.id) {
      case 'SM_IDC机房楼':
        // Store.commit('setLandmarkLayerIdObj', '')
        // 删除标牌
        OverlayTip.removeModelTipClass(prevModelLayer)
        break
      case 'SM_IDC室内04':
        // Store.commit('setLandmarkLayerIdObj', '')
        // 删除标牌
        OverlayTip.removeModelTipClass(prevModelLayer)
        break
    }
  }

  static LandmarkLayerHover(res) {
    if (
      res.detail.idLayer == '园区-机柜点位'
    ) {
      return
    }
    OverlayTip.addOverLayTipClass({
      idObj: res.detail.idObj,
      com: 'Room',
      layerType: 'landmarkLayer',
    })
    Store.commit(
      'setLandmarkLayerIdObj',
      res.detail.idLayer.slice(3, 10) + res.detail.idObj.slice(-2)
    )
  }
  static LandmarkLayerUnhover(res) {
    if (
      res.detail.idLayer == '园区-空调' ||
      res.detail.idLayer == '园区-环境监测设备'
    ) {
      return
    }
    // 删除标牌
    OverlayTip.removeOverLayTip()
    // Store.commit('setLandmarkLayerIdObj', '')
  }
}